export const parseDate = (iso: string): Date => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const formatDate = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const todayIso = (): string => formatDate(new Date());

export const addDays = (iso: string, days: number): string => {
  const d = parseDate(iso);
  d.setDate(d.getDate() + days);
  return formatDate(d);
};

export const diffDays = (startIso: string, endIso: string): number =>
  Math.round(
    (parseDate(endIso).getTime() - parseDate(startIso).getTime()) / 86_400_000
  );

export const minIso = (isos: string[]): string =>
  isos.length === 0
    ? todayIso()
    : isos.reduce((a, b) => (a <= b ? a : b));


export const maxIso = (isos: string[]): string =>
  isos.length === 0
    ? todayIso()
    : isos.reduce((a, b) => (a <= b ? b : a));
